// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__n2t-S","container":"Skills_container__CuNfH","skillList":"Skills_skillList__b-ehA"};